import { createStore } from "vuex";

import state from "./state.js";
import mutations from "./mutations.js";
import actions from "./actions.js";

// MODULES
import alert from "./modules/alert";

export default createStore({
  state,
  mutations,
  actions,
  modules: {
    alert
  },
});
